module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "mainDiv"
    }
  }, [_c('transition-group', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    key: "navBar",
    staticClass: "col-xs-12 text-center"
  }, [_c('button', {
    class: _vm.audioEngageClass,
    attrs: {
      "id": "mobileBtn"
    },
    on: {
      "~click": function($event) {
        return _vm.mobileEngage($event)
      }
    }
  }, [_vm._v("\t\n\t\t \t\t" + _vm._s(_vm.mobileTxt) + "\n\t\t \t\t")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMobileText),
      expression: "showMobileText"
    }],
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "welcomeMobileText"
    }
  }, [_vm._v(" \n\t\t \t\t\tAccess this app on your computer for extra effects and reactive backgrounds.\n\t\t \t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', {
    class: _vm.bellSlash
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t    \tPlease make sure your "), _c('strong', [_vm._v(" mute button is off ")]), _vm._v(" and volume is engaged.\n\t\t \t")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c763495","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile.vue
// module id = 65
// module chunks = 0